export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1544411047-c491e34a24e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  portrait: "/about/amiran-speaking.jpg",
};

export const STATS = [
  { target: 12, suffix: "", label: "Years in Business" },
  { target: 84, suffix: "", label: "Deals Closed" },
  { target: 36, suffix: "", label: "Partners & Clients" },
  { target: 8, suffix: "", label: "Ventures Launched" },
];

export const SKILLS = [
  "Venture Building",
  "Growth Strategy",
  "Fundraising",
  "Team Leadership",
  "Product Development",
  "Operations",
];

export const INVITE_INTRO =
  "For journalists, editors, podcasters, bloggers, and event organizers — I'm open to interviews, guest appearances, and speaking engagements. If you're working on a story or planning a conversation, here's how we can collaborate.";

export const INVITE_FORMATS = [
  {
    num: "01",
    name: "Podcast Guest",
    desc: "In-depth conversations on entrepreneurship, building SaaS and fintech ventures, and scaling companies across borders — remote or in-studio.",
  },
  {
    num: "02",
    name: "Press & Interviews",
    desc: "Print, online, and broadcast interviews. Available for feature stories, expert quotes, and Q&A pieces on business and investment.",
  },
  {
    num: "03",
    name: "Keynotes & Panels",
    desc: "Talks and moderated panels at conferences, summits, and demo days — on innovation, fundraising, and scaling companies.",
  },
  {
    num: "04",
    name: "Fireside Chats",
    desc: "Intimate on-stage or on-camera conversations for communities, accelerators, and universities.",
  },
  {
    num: "05",
    name: "Blog & Written Q&A",
    desc: "Guest columns, written interviews, and expert commentary for publications and personal blogs.",
  },
  {
    num: "06",
    name: "Workshops & Mentoring",
    desc: "Hands-on sessions and masterclasses for founders — from idea validation to go-to-market and investor readiness.",
  },
];

export const INVITE_TOPICS = [
  "Venture Building",
  "Startup Fundraising",
  "Scaling in Emerging Markets",
  "Scaling Across Borders",
  "Leadership & Team Culture",
  "Product & Growth",
];

export const PORTFOLIO = [
  {
    title: "B2B Hub",
    category: "saas",
    meta: "Business OS · SaaS",
    desc: "A complete business operating system — AI website & app builders, company formation, CRM, HR, payroll, invoicing and a developer API.",
    url: "https://b2bhub.ltd",
    span: "wide",
    img: "https://images.unsplash.com/photo-1597673030062-0a0f1a801a31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    title: "Astra Terminal",
    category: "fintech",
    meta: "Fintech · Brokerage Tech",
    desc: "White-label platform to launch a brokerage in days — trading terminal, admin dashboard, client portal and on-chain crypto payments.",
    url: "https://astraterminal.net",
    img: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "FX Astra",
    category: "fintech",
    meta: "Fintech · Broker Intelligence",
    desc: "A leading forex broker intelligence platform — broker comparison, live charts, economic calendar and market news.",
    url: "https://fxastra.com",
    img: "https://images.unsplash.com/photo-1560221328-12fe60f83ab8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Dezinfector",
    category: "services",
    meta: "Services · Disinfection",
    desc: "Professional 24/7 disinfection and pest control — insect and rodent control, mold and weed removal, across a nationwide service network.",
    url: "https://dezinfector.com.ua",
    span: "wide",
    img: "https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
];

export const FILTERS = [
  { key: "all", label: "All" },
  { key: "saas", label: "SaaS" },
  { key: "fintech", label: "Fintech" },
  { key: "services", label: "Services" },
];

export const PROCESS = [
  { num: "01", title: "Discovery", desc: "Deep listening — understanding the market, the problem, the customer, and the constraints to establish a clear opportunity thesis." },
  { num: "02", title: "Strategy", desc: "Translating insights into bold business models — exploring positioning, revenue strategies, and go-to-market approaches through rapid iteration." },
  { num: "03", title: "Build", desc: "Turning strategy into reality — assembling the right team, building the product, and testing with real customers as fast as possible." },
  { num: "04", title: "Scale", desc: "Growing what works — optimising operations, expanding markets, and building systems to sustain long-term, profitable growth." },
];

export const TESTIMONIALS = [
  {
    text: "Amiran took us from an idea to a live brokerage in a matter of weeks. Astra Terminal handled the terminal, back office, and payments so we could focus entirely on our clients.",
    initials: "DW",
    name: "Daniel Weber",
    role: "Founder · Brokerage Partner",
  },
  {
    text: "B2B Hub genuinely changed how we launched our company — formation, CRM, invoicing, and our website all in one place. Amiran's product vision is years ahead.",
    initials: "SR",
    name: "Sofia Romano",
    role: "Co-founder · SaaS Client",
  },
  {
    text: "Working with Amiran means clarity and speed. He cuts straight to what matters, brings a strong international network, and stays committed to long-term results.",
    initials: "MK",
    name: "Marcus Klein",
    role: "Managing Partner · Investment Group",
  },
];

export const MEDIA = [
  { badge: "FORBES", outlet: "Forbes", headline: "The Founder Building a Full-Stack Operating System for the Next Generation of Companies", date: "March 2024", kind: "Feature Interview" },
  { badge: "FIN\nTECH", outlet: "Fintech Times", headline: "How Astra Terminal Lets Anyone Launch a Brokerage in Days, Not Months", date: "January 2024", kind: "Company Profile" },
  { badge: "SAAS\nMAG", outlet: "SaaS Magazine", headline: "Inside B2B Hub: One Platform to Start, Run and Scale a Business", date: "October 2023", kind: "Product Deep-Dive" },
  { badge: "STARTUP", outlet: "Startup Journal", headline: "A Serial Founder on Building Ventures That Scale Across Borders", date: "June 2023", kind: "Podcast Feature" },
];

export const GALLERY = [
  { src: "/gallery/photo-01.jpg", orient: "portrait" },
  { src: "/gallery/photo-03.jpg", orient: "landscape" },
  { src: "/gallery/photo-15.jpg", orient: "portrait" },
  { src: "/gallery/photo-04.jpg", orient: "landscape" },
  { src: "/gallery/photo-06.jpg", orient: "portrait" },
  { src: "/gallery/photo-08.jpg", orient: "landscape" },
  { src: "/gallery/photo-05.jpg", orient: "landscape" },
  { src: "/gallery/photo-12.jpg", orient: "portrait" },
  { src: "/gallery/photo-09.jpg", orient: "landscape" },
  { src: "/gallery/photo-17.jpg", orient: "portrait" },
  { src: "/gallery/photo-10.jpg", orient: "landscape" },
  { src: "/gallery/photo-18.jpg", orient: "portrait" },
  { src: "/gallery/photo-11.jpg", orient: "landscape" },
  { src: "/gallery/photo-02.jpg", orient: "portrait" },
  { src: "/gallery/photo-13.jpg", orient: "landscape" },
  { src: "/gallery/photo-14.jpg", orient: "landscape" },
  { src: "/gallery/photo-16.jpg", orient: "landscape" },
  { src: "/gallery/photo-20.jpg", orient: "landscape" },
  { src: "/gallery/photo-07.jpg", orient: "landscape" },
];

export const BOOKS = [
  {
    title: "Forex — 6 Steps to Financial Independence",
    localTitle: "ფორექსი",
    cover: "/book/forex-cover.jpg",
    year: "2024",
    desc:
      "After two years of abstract, improvised trading on Forex, I decided to build my own trading system — one that fit my goals and the realities of my life. In this book I break down the 6 steps to financial independence, whether or not you already have a financial background.",
    highlights: [
      "A practical, repeatable trading system",
      "6 clear steps to financial independence",
      "Written for beginners and self-taught traders",
    ],
    languages: [
      { label: "Georgian", status: "available" },
      { label: "English", status: "coming-soon" },
    ],
    url: "https://www.lit.ge/book/156425-foreqsi-amiran-azaladze/",
  },
];

export const NAV_LINKS = [
  { href: "#about", label: "About" },
  { href: "#invite", label: "Invite" },
  { href: "#portfolio", label: "Ventures" },
  { href: "#books", label: "Books" },
  { href: "#gallery", label: "Gallery" },
  { href: "#blog", label: "Blog" },
  { href: "#contact", label: "Contact" },
];
